// import Table from '@tiptap/extension-table'
import TiptapTable, {
    TableOptions,
    TableOptions as TiptapTableOptions,
} from "@tiptap/extension-table";
// @ts-ignore
import RenderViewCustomTable from "./RenderViewCustomTable.tsx"
import { ReactNodeViewRenderer } from "@tiptap/react";
const RenderCustomTable = TiptapTable.extend<TableOptions>({
    addNodeView() {
        return (props)=>{
            return ReactNodeViewRenderer(RenderViewCustomTable,{contentDOMElementTag:"tbody",})(props)
        }
    },
    addAttributes() {
        return {
            toggleHeaderRow: {
                default: false,
            },
            toggleHeaderCell: {
                default: false,
            },
            id:{
                default:crypto.randomUUID(),
                parseHTML: (element) => element.getAttribute("data-id") || crypto.randomUUID(),
                renderHTML: (attributes) => ({ "data-id": attributes.id }),
            },
            tableFixWidth:{
                default:null
            },
            tableCellNum:{
                default:2
            },
            ifhidden: {
                default: false,
                renderHTML: (attributes) => {
                    if (attributes.ifhidden === undefined) {
                        return {};
                    }
                    return {
                        ifhidden: attributes.ifhidden,
                    };
                },
            },
        }
    },
})

export { RenderCustomTable, RenderCustomTable as default };